import config from '../config'
export default [
  {
    url: '/',
    name: '个人中心',
    icon: 'HomeIcon',
  },
  {
    url: null,
    name: '我的赛事',
    slug: 'myMatch',
    icon: 'ListIcon',
    submenu: [
      {
        url: '/match/list',
        name: '参赛记录',
        slug: '',
      }
    ]
  },
  {
    url: null,
    name: '我的团队',
    slug: 'myTeam',
    icon: 'UsersIcon',
    submenu: [
      {
        url: '/team/create-list',
        name: '创建的团队',
        slug: ''
      },
      {
        url: '/team/join-list',
        name: '加入的团队',
        slug: ''
      },
    ]
  },
  {
    url: '/user/profile',
    name: '个人信息',
    icon: 'UserIcon',
    slug: ''
  },
  {
    header: '其他'
  },
  {
    url: config.matchHost,
    name: '前往赛事入口',
    icon: 'FlagIcon',
    slug: 'external',
    target: '_blank'
  }
]